import { atom } from 'recoil';

// Structure: { sectionName: [cardObjects] }
export const wishlistAtom = atom({
  key: 'wishlistAtom',
  default: {}  // or default: { sectionName: [] } if you want
});

export const userIDAtom = atom({
  key: 'userIDAtom',   // unique key for this atom
  default: '',         // default value is an empty string
});

export const chatMessagesAtom = atom({
  key: 'chatMessagesAtom', // unique ID
  default: [
    // {
    //   text: {
    //     reply:
    //       "Hey 😊 How's it going? I hope you're doing great today. Let me know how can I help you! 💕",
    //   },
    //   type: 'mindy',
    // },
  ],
});

export const crisisMessagesAtom = atom({
  key: 'crisisMessagesAtom', // unique ID
  default: [
    {
      text: {
        reply:
          "Hey, You are now in crisis mode",
      },
      type: 'mindy',
    },
  ],
});

export const sessionIDAtom = atom({
  key: 'sessionIDAtom', // unique ID
  default: '',          
});
